import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { theme } from '../../..';
import { IconProps, DEFAULT_IMAGE_SIZE } from '../icon';
import IconSvg from '../IconSvg';

const PackageClose = (props: IconProps) => {
  const [t] = useTranslation();
  const {
    id,
    color = theme.palette.color2.hex,
    description,
    dmId = 'dm-package-close',
    pointerEvents = 'none',
    secondColor,
    size = DEFAULT_IMAGE_SIZE,
    title = t('ds.icon.packageClose.title'),
    ...otherProps
  } = props; // we also need to define unused props because of otherProps

  return (
    <IconSvg
      id={id}
      description={description}
      dmId={dmId}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      {...otherProps}>
      <path
        fill={color}
        d="m21.146 5.487-3.177-1.18-8.798 3.852 2.829 1.196 8.128-3.437z"
      />
      <path
        fill={color}
        d="m14.922 3.175-2.3-.855a1.842 1.842 0 0 0 -1.284 0l-8.485 3.166 3.413 1.444z"
      />
      <path
        fill={color}
        d="m8.567 12.2a.354.354 0 0 1 -.486.329l-2.226-.895a.353.353 0 0 1 -.222-.329v-3.557l-3.633-1.537v10.641a1.828 1.828 0 0 0 1.166 1.711l8.334 3.271v-11.6l-2.933-1.245z"
      />
      <path
        fill={color}
        d="m12.5 21.834 8.333-3.273a1.828 1.828 0 0 0 1.167-1.709v-10.641l-9.5 4.018z"
      />
    </IconSvg>
  );
};

export default memo(PackageClose);
